var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"field"},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),(_vm.icon)?_c('v-icon',{staticClass:"icon",attrs:{"pack":"hv"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }